import { createDeepEqualSelector } from '@exodus/core-selectors/utils/deep-equal.js';
import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import lodash from 'lodash';
const { memoize } = lodash;
const selectorFactory = (allEnabledWalletAccountsSelector, isCustodialWalletSelector, getIsReadOnlyWalletAccountSelector, isLedgerSelector) => memoize((operation) => createDeepEqualSelector(allEnabledWalletAccountsSelector, isCustodialWalletSelector, getIsReadOnlyWalletAccountSelector, isLedgerSelector, (enabledWalletAccounts, isCustodial, isReadOnly, isLedger) => {
    let walletAccounts = enabledWalletAccounts.filter((acc) => !isCustodial(acc) && !isLedger(acc));
    if (operation === 'deposit') {
        walletAccounts = walletAccounts.filter((acc) => !isReadOnly(acc));
    }
    return walletAccounts;
}));
const createLightningSelectorDefinition = defineSelectorFactory({
    id: 'createLightning',
    selectorFactory,
    dependencies: [
        { selector: 'enabled' },
        { selector: 'isCustodial' },
        { selector: 'isReadOnly' },
        { selector: 'isLedger' },
    ],
});
export default createLightningSelectorDefinition;
